/* MOMAVO — Scroll Reveal + Hero Character Animation + Homepage Detection */
document.addEventListener('DOMContentLoaded', function() {

  /* --- Homepage Detection + Scroll Transition --- */
  const heroSection = document.querySelector('.momavo-hero, .momavo-hero-vid');
  if (heroSection) {
    document.body.classList.add('momavo-homepage');

    /* Toggle .momavo-header-scrolled at 80px scroll.
       Drives transparent → white header background transition.
       Uses rAF + 300ms cooldown to prevent rapid class toggling
       (which causes visual flicker when hovering near threshold). */
    var scrolled = false;
    var ticking = false;
    var lastToggle = 0;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var isScrolled = window.scrollY > 80;
          if (isScrolled !== scrolled) {
            var now = Date.now();
            if (now - lastToggle > 300) {
              scrolled = isScrolled;
              lastToggle = now;
              document.body.classList.toggle('momavo-header-scrolled', isScrolled);
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Inline Search Bar with Predictive Search (desktop) --- */
  var headerIcons = document.querySelector('.header__icons');
  if (headerIcons) {
    var searchWrap = document.createElement('div');
    searchWrap.className = 'momavo-inline-search';
    searchWrap.innerHTML =
      '<form action="/search" method="get" class="momavo-inline-search__form">' +
        '<input type="search" name="q" placeholder="Search" class="momavo-inline-search__input" autocomplete="off" aria-label="Search products">' +
        '<button type="submit" class="momavo-inline-search__btn" aria-label="Search">' +
          '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.65" y1="16.65" x2="21" y2="21"/></svg>' +
        '</button>' +
      '</form>' +
      '<div class="momavo-inline-search__results" aria-live="polite"></div>';
    headerIcons.insertBefore(searchWrap, headerIcons.firstChild);

    /* Predictive search logic */
    var searchInput = searchWrap.querySelector('.momavo-inline-search__input');
    var resultsBox = searchWrap.querySelector('.momavo-inline-search__results');
    var searchTimer = null;
    var searchCache = {};
    var abortCtrl = null;

    function closePredictive() {
      resultsBox.innerHTML = '';
      resultsBox.classList.remove('is-open');
    }

    function renderResults(data) {
      var products = data.resources && data.resources.results && data.resources.results.products;
      if (!products || products.length === 0) {
        closePredictive();
        return;
      }
      var html = '<ul class="momavo-inline-search__list">';
      for (var i = 0; i < products.length && i < 6; i++) {
        var p = products[i];
        var img = p.image ? '<img src="' + p.image.replace(/(\.[^.]+)$/, '_100x$1') + '" alt="" width="40" height="40" loading="lazy" class="momavo-inline-search__thumb">' : '';
        var price = p.price ? '<span class="momavo-inline-search__price">' + (window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(parseInt(p.price) * 100) : '$' + parseFloat(p.price).toFixed(2)) + '</span>' : '';
        html += '<li class="momavo-inline-search__item"><a href="' + p.url + '" class="momavo-inline-search__link">' +
          img +
          '<span class="momavo-inline-search__info"><span class="momavo-inline-search__name">' + p.title + '</span>' + price + '</span>' +
        '</a></li>';
      }
      html += '</ul>';
      html += '<a href="/search?q=' + encodeURIComponent(searchInput.value) + '" class="momavo-inline-search__view-all">View all results</a>';
      resultsBox.innerHTML = html;
      resultsBox.classList.add('is-open');
    }

    function fetchSuggestions(query) {
      if (searchCache[query]) {
        renderResults(searchCache[query]);
        return;
      }
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6', {
        signal: abortCtrl.signal
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        searchCache[query] = data;
        renderResults(data);
      })
      .catch(function(e) {
        if (e.name !== 'AbortError') closePredictive();
      });
    }

    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      var val = searchInput.value.trim();
      if (val.length < 2) { closePredictive(); return; }
      searchTimer = setTimeout(function() { fetchSuggestions(val); }, 250);
    });

    searchInput.addEventListener('focus', function() {
      var val = searchInput.value.trim();
      if (val.length >= 2) fetchSuggestions(val);
    });

    document.addEventListener('click', function(e) {
      if (!searchWrap.contains(e.target)) closePredictive();
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closePredictive(); searchInput.blur(); }
    });
  }

  /* --- Hero Video Pause/Resume on Visibility --- */
  var heroVid = document.querySelector('.momavo-hero-vid__video');
  if (heroVid) {
    var vidObserver = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        heroVid.play();
      } else {
        heroVid.pause();
      }
    }, { threshold: 0.1 });
    vidObserver.observe(heroVid);
  }

  /* --- Scroll Reveal (IntersectionObserver) --- */
  var revealObserver = new IntersectionObserver(function(entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    }
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  function momavoObserveReveals(root) {
    var els = (root || document).querySelectorAll('.momavo-reveal:not(.is-visible)');
    for (var i = 0; i < els.length; i++) {
      revealObserver.observe(els[i]);
    }
  }

  momavoObserveReveals();

  /* Shopify theme editor: re-observe after section reload */
  document.addEventListener('shopify:section:load', function(e) {
    momavoObserveReveals(e.target);
    momavoInitCardImages(e.target);
    momavoInitSparkles(e.target);
    momavoInitMegaImages(e.target);
  });

  /* --- Hero Word Character Reveal --- */
  const heroWord = document.querySelector('[data-word]');
  if (heroWord) {
    const word = heroWord.getAttribute('data-word');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    heroWord.innerHTML = '';

    for (let i = 0; i < word.length; i++) {
      const span = document.createElement('span');
      span.className = 'momavo-hero__char';
      span.textContent = word[i];

      if (!prefersReducedMotion) {
        span.style.animationDelay = (0.6 + i * 0.08) + 's';
      }

      heroWord.appendChild(span);
    }
  }

  /* --- Mega Menu Image Fade-In ---
     Lightweight: just adds is-loaded class on load for CSS opacity transition.
     No animations, no blobs — just a gentle 0.35s fade from cream placeholder. */
  function momavoInitMegaImages(root) {
    var imgs = (root || document).querySelectorAll('.mega-menu__product-photo');
    for (var i = 0; i < imgs.length; i++) {
      (function(img) {
        var wrap = img.closest('.mega-menu__product-img');
        if (!wrap) return;
        if (img.complete && img.naturalWidth > 0) {
          wrap.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function() { wrap.classList.add('is-loaded'); });
        }
      })(imgs[i]);
    }
  }
  momavoInitMegaImages();

  /* --- Mega Menu photos load on first open (saves ~400 KB on every page view) --- */
  function momavoLoadMegaPhotos(root) {
    var imgs = root.querySelectorAll('img.mega-menu__product-photo[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].srcset = imgs[i].getAttribute('data-srcset');
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  }
  document.querySelectorAll('details.mega-menu').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) momavoLoadMegaPhotos(d); });
    var s = d.querySelector('summary');
    if (s) s.addEventListener('mouseenter', function () { momavoLoadMegaPhotos(d); }, { once: true });
  });

  /* --- Image Fade-In (MOMAVO cards + Dawn product/card images) ---
     Adds 'is-loaded' class to wrapper when its image finishes loading.
     CSS-only shimmer placeholder; no sparkles, no timers. */
  var SHIMMER_SEL = '.momavo-card__img-wrap, .momavo-nebula';
  var IMG_SEL = '.momavo-card__img-wrap img, .momavo-nebula img';

  function momavoRevealImage(img) {
    var wrap = img.closest('.momavo-card__img-wrap') || img.closest('.momavo-nebula');
    if (wrap) wrap.classList.add('is-loaded');
  }

  function momavoInitCardImages(root) {
    var imgs = (root || document).querySelectorAll(IMG_SEL);
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth > 0) {
        momavoRevealImage(imgs[i]);
      } else {
        imgs[i].addEventListener('load', function() { momavoRevealImage(this); });
      }
    }
  }

  momavoInitCardImages();

  /* Watch for dynamically added cards (Load More AJAX) */
  var grids = document.querySelectorAll('[data-momavo-grid]');
  if (grids.length > 0 && typeof MutationObserver !== 'undefined') {
    var gridObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            momavoInitCardImages(node);
          }
        });
      });
    });
    for (var g = 0; g < grids.length; g++) {
      gridObserver.observe(grids[g], { childList: true });
    }
  }

  /* --- Mega Menu: Hover Intent (Desktop) ---
     Opens mega menu on mouseenter with 100ms delay.
     Closes on mouseleave with 180ms delay.
     When entering a new menu, instantly close all others (no flicker).
     Touch devices keep the default click behavior via <details>/<summary>. */
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouch && window.matchMedia('(min-width: 990px)').matches) {
    var megaMenus = document.querySelectorAll('.mega-menu');
    var allTimers = [];

    function closeAllMenusExcept(except) {
      for (var i = 0; i < megaMenus.length; i++) {
        if (megaMenus[i] !== except && megaMenus[i].open) {
          megaMenus[i].open = false;
        }
        if (allTimers[i] && megaMenus[i] !== except) {
          clearTimeout(allTimers[i].open);
          clearTimeout(allTimers[i].close);
          allTimers[i].open = null;
          allTimers[i].close = null;
        }
      }
    }

    for (var m = 0; m < megaMenus.length; m++) {
      allTimers[m] = { open: null, close: null };
      (function(details, idx) {
        var summary = details.querySelector('summary');
        if (!summary) return;

        details.addEventListener('mouseenter', function() {
          clearTimeout(allTimers[idx].close);
          allTimers[idx].close = null;
          closeAllMenusExcept(details);
          allTimers[idx].open = setTimeout(function() {
            if (!details.open) {
              details.open = true;
            }
          }, 100);
        });

        details.addEventListener('mouseleave', function() {
          clearTimeout(allTimers[idx].open);
          allTimers[idx].open = null;
          allTimers[idx].close = setTimeout(function() {
            if (details.open) {
              details.open = false;
            }
          }, 180);
        });

        summary.addEventListener('click', function(e) {
          if (details.open) {
            e.preventDefault();
            details.open = false;
          }
        });
      })(megaMenus[m], m);
    }
  }

  /* --- Mega Menu: Tab Switching ---
     Hover (desktop) or click (touch) on sidebar tabs to switch
     the visible panel in the center content area. */
  function momavoInitMegaTabs(container) {
      var tabs = container.querySelectorAll('.mega-menu__tab');
      var panels = container.querySelectorAll('.mega-menu__panel');
      if (!tabs.length || !panels.length) return;

      function activateTab(tabIndex) {
        for (var t = 0; t < tabs.length; t++) {
          var isActive = tabs[t].getAttribute('data-mega-tab') === String(tabIndex);
          tabs[t].classList.toggle('mega-menu__tab--active', isActive);
          tabs[t].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
        for (var p = 0; p < panels.length; p++) {
          var isActive = panels[p].getAttribute('data-mega-panel') === String(tabIndex);
          panels[p].classList.toggle('mega-menu__panel--active', isActive);
        }
      }

      for (var ti = 0; ti < tabs.length; ti++) {
        (function(tab) {
          /* Desktop: hover to switch tabs */
          tab.addEventListener('mouseenter', function() {
            activateTab(this.getAttribute('data-mega-tab'));
          });
          /* Touch/keyboard: click to switch tabs */
          tab.addEventListener('click', function(e) {
            e.preventDefault();
            activateTab(this.getAttribute('data-mega-tab'));
          });
          /* Keyboard: arrow keys for tab navigation */
          tab.addEventListener('keydown', function(e) {
            var idx = Array.prototype.indexOf.call(tabs, this);
            if (e.key === 'ArrowDown' && idx < tabs.length - 1) {
              e.preventDefault();
              tabs[idx + 1].focus();
              activateTab(tabs[idx + 1].getAttribute('data-mega-tab'));
            } else if (e.key === 'ArrowUp' && idx > 0) {
              e.preventDefault();
              tabs[idx - 1].focus();
              activateTab(tabs[idx - 1].getAttribute('data-mega-tab'));
            }
          });
        })(tabs[ti]);
      }
  }
  document.querySelectorAll('.mega-menu__content').forEach(momavoInitMegaTabs);

  /* --- Mega Menu panels: fetched on first hover (or when the browser is idle on desktop).
     Phones use the drawer and never download them (~250 KB less HTML per page). --- */
  var mmSlots = document.querySelectorAll('[data-mm-lazy]');
  var mmReq = null;
  function momavoLoadMegaPanels() {
    if (mmReq || !mmSlots.length) return;
    mmReq = fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?section_id=mega-menu-panels')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        mmSlots.forEach(function (slot) {
          var src = doc.querySelector('[data-mm-panel="' + slot.getAttribute('data-mm-lazy') + '"]');
          if (!src) return;
          slot.innerHTML = src.innerHTML;
          slot.removeAttribute('data-mm-lazy');
          var box = slot.closest('.mega-menu__content');
          momavoInitMegaTabs(box);
          momavoInitMegaImages(box);
          var d = slot.closest('details');
          if (d && d.open) momavoLoadMegaPhotos(d);
        });
      })
      .catch(function () { mmReq = null; });
  }
  var mmNav = document.querySelector('.header__inline-menu');
  if (mmNav && mmSlots.length) {
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { mmNav.addEventListener(ev, momavoLoadMegaPanels, { once: true, passive: true }); });
    if (window.matchMedia('(min-width: 990px)').matches) {
      window.addEventListener('load', function () { setTimeout(momavoLoadMegaPanels, 1500); });
    }
  }
});
